import React from 'react';
import Logo from '../../../components/logo';
import SuperImage from '../../../components/superimage';
import { Link } from '@reach/router';

      
const Marketing = ({cb}) => {

  return (

    <>
  <main>
        <div
        className='small-container owl col-center align-center '>
      
      <br/>
        <Logo/>
  
          <p className="txt-l -purple">Know your game. Raise your game.</p>
        <div className='row-center align-center padded-children-right'>
            <button type="button" onClick={cb} className='io-unbutton io-button-pill -accent _accent-alpha txt-xl txt-uppercase'>
              Start
            </button>
        </div>
      </div>
      <br/>
      <br/>

<div className="grid grid--3 padded-x">
  <SuperImage
          src="https://firebasestorage.googleapis.com/v0/b/padel-ab4bc.appspot.com/o/2020%2Fnew-l.png?alt=media&token=11844fd5-1a68-4589-b7fb-0ca088a9a228"
          all1="Guardar partidxs"
         
        />
          <SuperImage
          src="https://firebasestorage.googleapis.com/v0/b/padel-ab4bc.appspot.com/o/2020%2Fdashboard-l.png?alt=media&token=064c8927-ec43-408e-8d2c-d8c1d6ed4524"
          all1="Estadísticas"
         
        />
          <SuperImage
          src="https://firebasestorage.googleapis.com/v0/b/padel-ab4bc.appspot.com/o/2020%2Fprofile.png?alt=media&token=b58cbd6a-f73d-4d9a-9f58-a15d8f945902"
          all1="Customiza pala y avatar"
        />
</div>
     <br/>
      <br/>
      </main>
  <footer className='row-center align-start'>
          <Link to='/terms-of-service' className='pill-button link-no-underline'>
            T.O.S
          </Link>
      </footer>
    </>

  );
};

export default Marketing;
 
